const subUsersNL = {
    "view": {
        "table": {
            "title": "Uw subgebruikerslijst",
            "column": {
                "username": "Gebruikersnaam",
                "email": "E-mail",
                "first_name": "Voornaam",
                "last_name": "Achternaam",
                "company": "Bedrijf",
                "sub_user_deal": "Deal (%)",
                "contract_expiry": "Contractvervaldatum",
                "is_active": "Actief",
                "action": "Actie"
            },
            "button": {
                "edit": "Bewerken",
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "label": {
                "yes": "Ja",
                "no": "Nee"
            },
            "dropdown": {
                "action": "Actie",
                "edit": "Bewerken",
                "activate": "Activeren",
                "deactivate": "Deactiveren"
            }
        },
        "message": {
            "successUpdated": "Subgebruikersaccount is bijgewerkt!",
            "successActivated": "Subgebruikersaccount is geactiveerd!",
            "successDeactivated": "Subgebruikersaccount is gedeactiveerd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "premiumUsersOnly": "Deze functie wordt alleen aangeboden aan Premium Gebruikers. Neem contact op met het ondersteuningsteam als u uw account wilt upgraden.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        },
        "modal": {
            "activateSubuser": {
                "header": "Activeer Subgebruiker",
                "body": "Weet u zeker dat u Subgebruiker {{username}} wilt activeren?"
            },
            "deactivateSubuser": {
                "header": "Deactiveer Subgebruiker",
                "body": "Weet u zeker dat u Subgebruiker {{username}} wilt deactiveren?"
            },
            "button": {
                "cancel": "Annuleren",
                "edit": "Bewerken",
                "activate": "Activeren",
                "deactivate": "Deactiveren"
            }
        }
    },
    "add": {
        "title": "Subgebruiker Toevoegen",
        "form": {
            "label": {
                "personalDetails": "Persoonlijke Gegevens",
                "firstName": "Voornaam",
                "lastName": "Achternaam",
                "email": "E-mail",
                "username": "Gebruikersnaam",
                "password": "Wachtwoord",
                "confirmPassword": "Bevestig Wachtwoord",
                "businessDetails": "Zakelijke Gegevens",
                "companyName": "Bedrijfsnaam",
                "contractExpiry": "Contractvervaldatum",
                "subUserDeal": "Subgebruiker Deal (%)",
                "nationalTaxNumber": "Nationaal Belastingnummer",
                "businessRegistrationNumber": "Bedrijfsregistratienummer",
                "contactDetails": "Contactgegevens",
                "streetAndNumber": "Straat en huisnummer",
                "postalCode": "Postcode",
                "city": "Stad",
                "country": "Land",
                "phoneNumber": "Telefoonnummer"
            },
            "help_text": {
                "contractExpiry": "Opmerking: Contractvervaldatum kan niet eerder worden ingesteld dan {{afterOneYear}}."
            },
            "button": {
                "submit": "Verzenden"
            }
        },
        "message": {
            "success": "Subgebruiker is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "header": "Subgebruiker Toevoegen",
            "body": "Weet u zeker dat u een nieuwe subgebruiker wilt aanmaken?"
        }
    },
    "update": {
        "title": "Subgebruiker Bewerken",
        "form": {
            "label": {
                "personalDetails": "Persoonlijke Gegevens",
                "firstName": "Voornaam",
                "lastName": "Achternaam",
                "email": "E-mail",
                "username": "Gebruikersnaam",
                "password": "Wachtwoord",
                "confirmPassword": "Bevestig Wachtwoord",
                "businessDetails": "Zakelijke Gegevens",
                "companyName": "Bedrijfsnaam",
                "contractExpiry": "Contractvervaldatum",
                "subUserDeal": "Subgebruiker Deal (%)",
                "nationalTaxNumber": "Nationaal Belastingnummer",
                "businessRegistrationNumber": "Bedrijfsregistratienummer",
                "contactDetails": "Contactgegevens",
                "streetAndNumber": "Straat en huisnummer",
                "postalCode": "Postcode",
                "city": "Stad",
                "country": "Land",
                "phoneNumber": "Telefoonnummer"
            },
            "help_text": {
                "contractExpiry": "Opmerking: Contractvervaldatum kan niet eerder worden ingesteld dan {{afterOneYear}}."
            },
            "button": {
                "submit": "Verzenden"
            }
        },
        "message": {
            "success": "Subgebruiker is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    }
};

export default subUsersNL;